const data = {
  Accessories: {
    'Belt_-_Apothecary_Pack': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Belt_-_Belted_Sash': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Belt_-_Asymmetrical_Obi': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Belt_-_Careto_Quilt': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Belt_-_Champion_Belt': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Belt_-_Demonic_Buckle': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Belt_-_Gladiator_Brace': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Belt_-_Martial_Arts_Belt': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Belt_-_Obi': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Belt_-_Insurgent_Belt': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Belt_-_Serpent_Belt': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Belt_-_Silk_Belt': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Belt_-_Simple_Belt': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Belt_-_Shoulder_Harness': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Belt_-_Sporran': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Belt_-_Unity_Belt': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Belt_-_Wide_Belt': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Body_-_Arm_Sling': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Beige.png',
      'secondary_Brick.png',
      'secondary_Bronze.png',
      'secondary_Caucasian.png',
      'secondary_Celestial.png',
      'secondary_Chestnut.png',
      'secondary_Chocolate.png',
      'secondary_Cinder.png',
      'secondary_Dust.png',
      'secondary_Grey.png',
      'secondary_Honey.png',
      'secondary_Jade.png',
      'secondary_Lavender.png',
      'secondary_Olive.png',
      'secondary_Pale.png',
      'secondary_Porcelain.png',
      'secondary_Sanguine.png',
      'secondary_Skeleton.png',
      'secondary_Storm.png',
      'secondary_Sunbeam.png',
      'secondary_Swarthy.png',
    ],
    'Body_-_Berserker_Chestpiece': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Body_-_Apron': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Body_-_Gorget_Emblem': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Body_-_Yuigesa': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Body_-_Parrot': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Gloves_-_Brawler_Gauntlets': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Gloves_-_Arm_Wraps': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Gloves_-_Clawed_Gauntlet': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Gloves_-_Couter': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Gloves_-_Demon_Gauntlet': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Gloves_-_Falconer_Glove': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Gloves_-_Manica': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Gloves_-_Huntress_Gauntlet': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Gloves_-_Plate_Gauntlets': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Gloves_-_Pickpocket_Gloves': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Gloves_-_Robotic_Claw': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Gloves_-_Segmented_Gauntlets': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Gloves_-_Studded_Bracer': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Head_-_Aura_Crown': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Head_-_Bandages': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Head_-_Cap_Badge': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Head_-_Bitten_Dagger': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Head_-_Big_Leaf': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Head_-_Cascade_Feather': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Head_-_Clown_Nose': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Head_-_Cockade': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Head_-_Decorative_Plumage': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Head_-_Fukigaeshi': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Head_-_Garish_Feather': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Head_-_Giant_Jaw': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Head_-_Halo': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Head_-_Grave_Feather': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Head_-_Helmet_Chevron': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Head_-_Laurel_Wreath': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Head_-_Isis_Disk': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Head_-_Menpo': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Head_-_Maedate': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Head_-_Moon_Crest': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Head_-_Pilgrims_Badge': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Head_-_Skull_Token': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Head_-_Rolled_Cigar': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Head_-_Smokers_Pipe': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Head_-_Rose': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Head_-_Succubus_Wings': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Head_-_Uraeus': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Head_-_Wing_Adornment': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Head_-_V_Fin': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Jewelry_-_Amulet': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Head_-_Wings_of_the_Gaul': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Jewelry_-_Bangle': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Jewelry_-_Armband': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Jewelry_-_Bone_Necklace': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Jewelry_-_Disc_Earrings': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Jewelry_-_Gorgerine': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Jewelry_-_Hoop_Earring': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Jewelry_-_Religious_Earing': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Mask_-_Bandit_Scarf': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Mask_-_Battoulah': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Jewelry_-_Torc': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Mask_-_Blindfold': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Mask_-_Buffalo_Shaman': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Mask_-_Careto_Grimace': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Mask_-_Death_Mask': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Mask_-_Carnival': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Mask_-_Eye_Mask': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Mask_-_Hannya': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Mask_-_Hyottoko': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Mask_-_Kitsune': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Mask_-_Mystic_Identity': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Mask_-_Namahage': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Mask_-_Jungle_Shaman': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Mask_-_Onnamen': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Mask_-_Plague_Doctor': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Mask_-_Nganga_Healer': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Mask_-_Secret_Identity': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Mask_-_Sand_Filter': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Mask_-_Skull': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Mask_-_Stoic': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Mask_-_Yashmak': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Mask_-_Tengu': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Neck_-_Agile_Bevor': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Mask_-_Tribal': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Neck_-_Arcane_Collar': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Neck_-_Ascot': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Neck_-_Assassin_Shawl': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Neck_-_Bowtie': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Neck_-_Cavalier_Collar': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Neck_-_Cartwheel_Ruff': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Neck_-_Bevor': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Neck_-_Desert_Scarf': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Neck_-_Drawn_Hood': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Neck_-_Folk_Pendant': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Neck_-_Fur_Collar': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Neck_-_Jabot': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Neck_-_Jester_Garland': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Neck_-_Litham': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Neck_-_Magic_Scarf': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Neck_-_Necktie': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Neck_-_Nodowa': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Neck_-_Novelty_Bowtie': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Neck_-_Plate_Gorget': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Neck_-_Neckerchief': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Neck_-_Scarf': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Neck_-_Tallit': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Neck_-_Turned_Down_Collar': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Shoulders_-_Conch_Fixture': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Shoulders_-_Ailette': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Shoulders_-_Demonic_Spaulders': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Shoulders_-_Ecranche': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Shoulders_-_Emperor_Gardbrace': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Shoulders_-_Epaulettes': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Shoulders_-_Galerus': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Shoulders_-_Heavy_Pauldrons': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Shoulders_-_Huntress_Pauldron': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Shoulders_-_Necromancer_Shawl': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Shoulders_-_Mountain_Pauldrons': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Shoulders_-_Massive_Gardbrace': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Shoulders_-_Ornate_Besagew': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Shoulders_-_Rank_Slide': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Shoulders_-_Rounded_Spaulder': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Shoulders_-_Scout_Shoulderplate': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Shoulders_-_Shaggy_Pauldrons': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Shoulders_-_Sode': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Shoulders_-_Tate_Eri': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Shoulders_-_Warrior_Pauldrons': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Visor_-_Avian_Visor': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Shoulders_-_Wing_Pauldrons': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Visor_-_Blast_Visor': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Visor_-_Frog_Visor': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Visor_-_Klappvisor': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Visor_-_Lifted_Parade_Visor': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Visor_-_Mech_Faceplate': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Visor_-_Parade_Visor': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Visor_-_Seeker_Kalkriese': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Visor_-_Slotted_Visor': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Visor_-_Vented_Kalkriese': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
  },
  Back: {
    'Cape_-_Ceremonial_Poncho': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Cape_-_Gossamer_Shawl': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Cape_-_Gunslinger_Poncho': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Cape_-_Duelist_Cloak': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Cape_-_Kollwana': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Cape_-_Leopard_Pelt': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Cape_-_Outsider_Cloak': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Cape_-_Leather_Cape': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Cape_-_Pellagrina': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Cape_-_Pilot_Capelette': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Cape_-_Ragged_Cape': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Cape_-_Royal_Cape': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Cape_-_Shaman_Cloak': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Cape_-_Swamp_Cloak': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Cape_-_Tatters': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Cape_-_Tonnag': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Cape_-_Wedding_Shawl': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Etc_-_Dorsal_Fin': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Etc_-_Hikers_Pack': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Etc_-_Homesteader_Backpack': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Etc_-_Insect_Abdomen': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Etc_-_Wind-Up_Key': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Tail_-_Demon': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Tail_-_Equine': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Tail_-_Fish': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Tail_-_Lizard': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Tail_-_Simian': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Wings_-_Avian': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Wings_-_Bat': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Wings_-_Butterfly': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Wings_-_Draconic': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Wings_-_Folded_Lunar': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Wings_-_Hieroglyph': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Wings_-_Moth': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Wings_-_Seraph': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Wings_-_Succubus': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Wings_-_Wispy': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'rimary_Copper.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
  },
  Back_Hand: {
    'Axe_-_Battle_Axe': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Axe_-_Execution_Axe': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Axe_-_Great_Axe': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Axe_-_Skeggox': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Club_-_Bec_De_Corbin': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Club_-_Ghioaga': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Club_-_Giant_Club': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Club_-_Kanabo': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Club_-_Meat_Club': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Club_-_Peasant_Flail': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Etc_-_Controlled_Flame': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Etc_-_Cross': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Etc_-_Doom_Gauntlet': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Etc_-_Falcon': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Etc_-_Open_Hand': [
      'primary_Beige.png',
      'primary_Brick.png',
      'primary_Bronze.png',
      'primary_Caucasian.png',
      'primary_Celestial.png',
      'primary_Chestnut.png',
      'primary_Chocolate.png',
      'primary_Cinder.png',
      'primary_Dust.png',
      'primary_Grey.png',
      'primary_Honey.png',
      'primary_Jade.png',
      'primary_Lavender.png',
      'primary_Olive.png',
      'primary_Pale.png',
      'primary_Porcelain.png',
      'primary_Sanguine.png',
      'primary_Skeleton.png',
      'primary_Storm.png',
      'primary_Sunbeam.png',
      'primary_Swarthy.png',
    ],
    'Etc_-_Gorilla_Gauntlet': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Etc_-_Pondering_Orb': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Etc_-_Spell_Book': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Etc_-_Tessen': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Instrument_-_Cello': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Instrument_-_Ceremonial_Rattle': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Instrument_-_Electric_Guitar': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Instrument_-_Fiddle': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Instrument_-_Lute': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Instrument_-_Pan_Pipes': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Instrument_-_Saxophone': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Instrument_-_Trumpet': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Knife_-_Dagger': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Knife_-_Katar': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Knife_-_Moon_Knife': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Ranged_-_Bow': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Ranged_-_Crossbow': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Staff_-_Caduceus': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Staff_-_Crosier': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Staff_-_Deep_Sea_Trident': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Staff_-_Demonic_Fork': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Staff_-_Druidic_Staff': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Staff_-_Hefty_Branch': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Staff_-_Keymaster_Staff': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Staff_-_Khakkhara': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Staff_-_Lightning_Staff': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Staff_-_Lance': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Staff_-_Naginata': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Staff_-_Necromancer_Staff': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Staff_-_Quarterstaff': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Staff_-_Pilgrims_Stick': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Staff_-_Shepherd_Crook': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Staff_-_Wizard_Staff': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Sword_-_Broad_Sword': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Sword_-_Butterfly_Sword': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Sword_-_Beam_Sword': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Sword_-_Hero_Sword': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Sword_-_Scimitar': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Sword_-_Shouldered_Katana': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Tool_-_Abundant_Pitcher': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Tool_-_Anchor': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Tool_-_Burlap_Sack': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Tool_-_Banner': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Tool_-_Drifter_Bindle': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Tool_-_Fishing_Pole': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Tool_-_Frothing_Stein': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Tool_-_Hammer': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Tool_-_Hatchet': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Tool_-_Hoe': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Tool_-_Lantern': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Tool_-_Pick_Axe': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Tool_-_Mop': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Tool_-_Pitchfork': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Tool_-_Scythe': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Tool_-_Shovel': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Tool_-_Torch': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
  },
  Face: {
    'Cosmetics_-_Blushing_Cheeks': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Cosmetics_-_Goddess_Eyeliner': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Cosmetics_-_Moxa_Burns': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Cosmetics_-_Jester_Facepaint': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Cosmetics_-_Oracle_Facepaint': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Cosmetics_-_Rouge': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Cosmetics_-_Shadow_Aura': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Cosmetics_-_Tribal_Paint': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Cosmetics_-_War_Paint': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Cosmetics_-_Nganga_Facepaint': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Cosmetics_-_Wrinkles': [
      'primary_Beige.png',
      'primary_Brick.png',
      'primary_Bronze.png',
      'primary_Caucasian.png',
      'primary_Celestial.png',
      'primary_Chestnut.png',
      'primary_Chocolate.png',
      'primary_Cinder.png',
      'primary_Dust.png',
      'primary_Grey.png',
      'primary_Honey.png',
      'primary_Jade.png',
      'primary_Lavender.png',
      'primary_Olive.png',
      'primary_Pale.png',
      'primary_Porcelain.png',
      'primary_Sanguine.png',
      'primary_Skeleton.png',
      'primary_Storm.png',
      'primary_Sunbeam.png',
      'primary_Swarthy.png',
    ],
    'Ears_-_Dryad': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Ears_-_Elvish': [
      'primary_Beige.png',
      'primary_Brick.png',
      'primary_Bronze.png',
      'primary_Caucasian.png',
      'primary_Celestial.png',
      'primary_Chestnut.png',
      'primary_Chocolate.png',
      'primary_Cinder.png',
      'primary_Dust.png',
      'primary_Grey.png',
      'primary_Honey.png',
      'primary_Jade.png',
      'primary_Lavender.png',
      'primary_Olive.png',
      'primary_Pale.png',
      'primary_Porcelain.png',
      'primary_Sanguine.png',
      'primary_Skeleton.png',
      'primary_Storm.png',
      'primary_Sunbeam.png',
      'primary_Swarthy.png',
    ],
    'Ears_-_Gauged': [
      'primary_Beige.png',
      'primary_Brick.png',
      'primary_Bronze.png',
      'primary_Caucasian.png',
      'primary_Celestial.png',
      'primary_Chestnut.png',
      'primary_Chocolate.png',
      'primary_Cinder.png',
      'primary_Dust.png',
      'primary_Grey.png',
      'primary_Honey.png',
      'primary_Jade.png',
      'primary_Lavender.png',
      'primary_Olive.png',
      'primary_Pale.png',
      'primary_Porcelain.png',
      'primary_Sanguine.png',
      'primary_Skeleton.png',
      'primary_Storm.png',
      'primary_Sunbeam.png',
      'primary_Swarthy.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Ears_-_Fins': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Ears_-_Pixie_Ears': [
      'primary_Beige.png',
      'primary_Brick.png',
      'primary_Bronze.png',
      'primary_Caucasian.png',
      'primary_Celestial.png',
      'primary_Chestnut.png',
      'primary_Chocolate.png',
      'primary_Cinder.png',
      'primary_Dust.png',
      'primary_Grey.png',
      'primary_Honey.png',
      'primary_Jade.png',
      'primary_Lavender.png',
      'primary_Olive.png',
      'primary_Pale.png',
      'primary_Porcelain.png',
      'primary_Sanguine.png',
      'primary_Skeleton.png',
      'primary_Storm.png',
      'primary_Sunbeam.png',
      'primary_Swarthy.png',
    ],
    'Ears_-_Pointed': [
      'primary_Beige.png',
      'primary_Brick.png',
      'primary_Bronze.png',
      'primary_Caucasian.png',
      'primary_Celestial.png',
      'primary_Chestnut.png',
      'primary_Chocolate.png',
      'primary_Cinder.png',
      'primary_Dust.png',
      'primary_Grey.png',
      'primary_Honey.png',
      'primary_Jade.png',
      'primary_Lavender.png',
      'primary_Olive.png',
      'primary_Pale.png',
      'primary_Porcelain.png',
      'primary_Sanguine.png',
      'primary_Skeleton.png',
      'primary_Storm.png',
      'primary_Sunbeam.png',
      'primary_Swarthy.png',
    ],
    'Ears_-_Rabbit': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'seconadry_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Ears_-_Satyr': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Ears_-_Troll_Ears': [
      'primary_Beige.png',
      'primary_Brick.png',
      'primary_Bronze.png',
      'primary_Caucasian.png',
      'primary_Celestial.png',
      'primary_Chestnut.png',
      'primary_Chocolate.png',
      'primary_Cinder.png',
      'primary_Dust.png',
      'primary_Grey.png',
      'primary_Honey.png',
      'primary_Jade.png',
      'primary_Lavender.png',
      'primary_Olive.png',
      'primary_Pale.png',
      'primary_Porcelain.png',
      'primary_Sanguine.png',
      'primary_Skeleton.png',
      'primary_Storm.png',
      'primary_Sunbeam.png',
      'primary_Swarthy.png',
    ],
    'Ears_-_Standard_Ear': [
      'primary_Beige.png',
      'primary_Brick.png',
      'primary_Bronze.png',
      'primary_Caucasian.png',
      'primary_Celestial.png',
      'primary_Chestnut.png',
      'primary_Chocolate.png',
      'primary_Cinder.png',
      'primary_Dust.png',
      'primary_Grey.png',
      'primary_Honey.png',
      'primary_Jade.png',
      'primary_Lavender.png',
      'primary_Olive.png',
      'primary_Pale.png',
      'primary_Porcelain.png',
      'primary_Sanguine.png',
      'primary_Skeleton.png',
      'primary_Storm.png',
      'primary_Sunbeam.png',
      'primary_Swarthy.png',
    ],
    'Eyebrows_-_Angry': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Eyebrows_-_Butterfly': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Eyebrows_-_Determined': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Eyebrows_-_Standard': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Eyebrows_-_Stern': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Facial_Hair_-_Anchor': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Facial_Hair_-_Aristocrat_Mustache': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Facial_Hair_-_Arcane_Beard': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Facial_Hair_-_Beggars_Scruff': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Facial_Hair_-_Bushy_Beard': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Facial_Hair_-_Cavalier_Mustache': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Facial_Hair_-_Bushy_Goatee': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Facial_Hair_-_Chieftain_Beard': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Facial_Hair_-_Dwarvish_Braids': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Facial_Hair_-_Distinguished_Beard': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Facial_Hair_-_Full_Beard': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Facial_Hair_-_Debonair': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Facial_Hair_-_Goatee': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Facial_Hair_-_Green_Man_Foliage': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Facial_Hair_-_Imperial': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Facial_Hair_-_Mustache': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Facial_Hair_-_Mutton_Chops': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Facial_Hair_-_Philosopher_Beard': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Facial_Hair_-_Jewelled_Beard': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Facial_Hair_-_Pirate_Beard': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Facial_Hair_-_Postiche': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Facial_Hair_-_Precision_Beard': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Facial_Hair_-_Royal_Beard': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Facial_Hair_-_Sheriff_Whiskers': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Facial_Hair_-_Sideburns': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Facial_Hair_-_Shepherd_Beard': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Facial_Hair_-_Stubble': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Glasses_-_Bionic_Lens': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Glasses_-_Comedic_Disguise': [
      'primary_Beige.png',
      'primary_Brick.png',
      'primary_Bronze.png',
      'primary_Caucasian.png',
      'primary_Celestial.png',
      'primary_Chestnut.png',
      'primary_Chocolate.png',
      'primary_Cinder.png',
      'primary_Dust.png',
      'primary_Grey.png',
      'primary_Honey.png',
      'primary_Jade.png',
      'primary_Lavender.png',
      'primary_None.png',
      'primary_Olive.png',
      'primary_Pale.png',
      'primary_Porcelain.png',
      'primary_Sanguine.png',
      'primary_Storm.png',
      'primary_Sunbeam.png',
      'primary_Swarthy.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Facial_Hair_-_Western': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Glasses_-_Insect_Lenses': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Glasses_-_High_Tech_Visor': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Glasses_-_Mercenary_Eyepatch': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Glasses_-_Goggles': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Glasses_-_Monocle': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Glasses_-_Occular_Implant': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Glasses_-_Pilot_Goggles': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Glasses_-_Printer_Spectacles': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Glasses_-_Pirate_Eyepatch': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Glasses_-_Tinted_Glasses': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Glasses_-_Spectacles': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Horns_-_Archfiend': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Horns_-_Devil': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Horns_-_Faun': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Horns_-_Demon': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Horns_-_Fleshy': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Beige.png',
      'secondary_Brick.png',
      'secondary_Bronze.png',
      'secondary_Caucasian.png',
      'secondary_Celestial.png',
      'secondary_Chestnut.png',
      'secondary_Chocolate.png',
      'secondary_Cinder.png',
      'secondary_Dust.png',
      'secondary_Grey.png',
      'secondary_Honey.png',
      'secondary_Jade.png',
      'secondary_Lavender.png',
      'secondary_Olive.png',
      'secondary_Pale.png',
      'secondary_Porcelain.png',
      'secondary_Sanguine.png',
      'secondary_Skeleton.png',
      'secondary_Storm.png',
      'secondary_Sunbeam.png',
      'secondary_Swarthy.png',
    ],
    'Horns_-_Oni_Horn': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Horns_-_Imp': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Horns_-_Horned_God_Antlers': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Horns_-_Sharp': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Horns_-_Underworld': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Mouth_-_Beak': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Mouth_-_Extended_Chin': [
      'primary_Beige.png',
      'primary_Brick.png',
      'primary_Bronze.png',
      'primary_Caucasian.png',
      'primary_Celestial.png',
      'primary_Chestnut.png',
      'primary_Chocolate.png',
      'primary_Cinder.png',
      'primary_Dust.png',
      'primary_Grey.png',
      'primary_Honey.png',
      'primary_Jade.png',
      'primary_Lavender.png',
      'primary_Olive.png',
      'primary_Pale.png',
      'primary_Porcelain.png',
      'primary_Sanguine.png',
      'primary_Skeleton.png',
      'primary_Storm.png',
      'primary_Sunbeam.png',
      'primary_Swarthy.png',
    ],
    'Mouth_-_Festering_Maw': [
      'primary_Beige.png',
      'primary_Brick.png',
      'primary_Bronze.png',
      'primary_Caucasian.png',
      'primary_Celestial.png',
      'primary_Chestnut.png',
      'primary_Chocolate.png',
      'primary_Cinder.png',
      'primary_Dust.png',
      'primary_Grey.png',
      'primary_Honey.png',
      'primary_Jade.png',
      'primary_Lavender.png',
      'primary_Olive.png',
      'primary_Pale.png',
      'primary_Porcelain.png',
      'primary_Sanguine.png',
      'primary_Skeleton.png',
      'primary_Storm.png',
      'primary_Sunbeam.png',
      'primary_Swarthy.png',
    ],
    'Mouth_-_Fangs': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Mouth_-_Buck_Teeth': [
      'primary_Beige.png',
      'primary_Brick.png',
      'primary_Bronze.png',
      'primary_Caucasian.png',
      'primary_Celestial.png',
      'primary_Chestnut.png',
      'primary_Chocolate.png',
      'primary_Cinder.png',
      'primary_Dust.png',
      'primary_Grey.png',
      'primary_Honey.png',
      'primary_Jade.png',
      'primary_Lavender.png',
      'primary_Olive.png',
      'primary_Pale.png',
      'primary_Porcelain.png',
      'primary_Sanguine.png',
      'primary_Skeleton.png',
      'primary_Storm.png',
      'primary_Sunbeam.png',
      'primary_Swarthy.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Mouth_-_Lovecraftian_Maw': [
      'primary_Beige.png',
      'primary_Brick.png',
      'primary_Bronze.png',
      'primary_Caucasian.png',
      'primary_Celestial.png',
      'primary_Chestnut.png',
      'primary_Chocolate.png',
      'primary_Cinder.png',
      'primary_Dust.png',
      'primary_Grey.png',
      'primary_Honey.png',
      'primary_Jade.png',
      'primary_Lavender.png',
      'primary_Olive.png',
      'primary_Pale.png',
      'primary_Porcelain.png',
      'primary_Sanguine.png',
      'primary_Skeleton.png',
      'primary_Storm.png',
      'primary_Sunbeam.png',
      'primary_Swarthy.png',
    ],
    'Mouth_-_Mandibles': [
      'primary_Beige.png',
      'primary_Brick.png',
      'primary_Bronze.png',
      'primary_Caucasian.png',
      'primary_Celestial.png',
      'primary_Chestnut.png',
      'primary_Chocolate.png',
      'primary_Cinder.png',
      'primary_Dust.png',
      'primary_Grey.png',
      'primary_Honey.png',
      'primary_Jade.png',
      'primary_Lavender.png',
      'primary_Olive.png',
      'primary_Pale.png',
      'primary_Porcelain.png',
      'primary_Sanguine.png',
      'primary_Skeleton.png',
      'primary_Storm.png',
      'primary_Sunbeam.png',
      'primary_Swarthy.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Mouth_-_Neutral': [
      'primary_Beige.png',
      'primary_Brick.png',
      'primary_Bronze.png',
      'primary_Caucasian.png',
      'primary_Celestial.png',
      'primary_Chestnut.png',
      'primary_Chocolate.png',
      'primary_Cinder.png',
      'primary_Dust.png',
      'primary_Grey.png',
      'primary_Honey.png',
      'primary_Jade.png',
      'primary_Lavender.png',
      'primary_Olive.png',
      'primary_Pale.png',
      'primary_Porcelain.png',
      'primary_Sanguine.png',
      'primary_Skeleton.png',
      'primary_Storm.png',
      'primary_Sunbeam.png',
      'primary_Swarthy.png',
    ],
    'Mouth_-_Orc_Jaw': [
      'primary_Beige.png',
      'primary_Brick.png',
      'primary_Bronze.png',
      'primary_Caucasian.png',
      'primary_Celestial.png',
      'primary_Chestnut.png',
      'primary_Chocolate.png',
      'primary_Cinder.png',
      'primary_Dust.png',
      'primary_Grey.png',
      'primary_Honey.png',
      'primary_Jade.png',
      'primary_Lavender.png',
      'primary_Olive.png',
      'primary_Pale.png',
      'primary_Porcelain.png',
      'primary_Sanguine.png',
      'primary_Skeleton.png',
      'primary_Storm.png',
      'primary_Sunbeam.png',
      'primary_Swarthy.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Mouth_-_Politician_Chin': [
      'primary_Beige.png',
      'primary_Brick.png',
      'primary_Bronze.png',
      'primary_Caucasian.png',
      'primary_Celestial.png',
      'primary_Chestnut.png',
      'primary_Chocolate.png',
      'primary_Cinder.png',
      'primary_Dust.png',
      'primary_Grey.png',
      'primary_Honey.png',
      'primary_Jade.png',
      'primary_Lavender.png',
      'primary_Olive.png',
      'primary_Pale.png',
      'primary_Porcelain.png',
      'primary_Sanguine.png',
      'primary_Skeleton.png',
      'primary_Storm.png',
      'primary_Sunbeam.png',
      'primary_Swarthy.png',
    ],
    'Mouth_-_Rabbit': [
      'primary_Beige.png',
      'primary_Brick.png',
      'primary_Bronze.png',
      'primary_Caucasian.png',
      'primary_Celestial.png',
      'primary_Chestnut.png',
      'primary_Chocolate.png',
      'primary_Cinder.png',
      'primary_Dust.png',
      'primary_Grey.png',
      'primary_Honey.png',
      'primary_Jade.png',
      'primary_Lavender.png',
      'primary_None.png',
      'primary_Olive.png',
      'primary_Pale.png',
      'primary_Porcelain.png',
      'primary_Sanguine.png',
      'primary_Skeleton.png',
      'primary_Storm.png',
      'primary_Sunbeam.png',
      'primary_Swarthy.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Mouth_-_Shouting': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Mouth_-_Toothy_Grin': [
      'primary_Beige.png',
      'primary_Bone.png',
      'primary_Brick.png',
      'primary_Bronze.png',
      'primary_Caucasian.png',
      'primary_Celestial.png',
      'primary_Chestnut.png',
      'primary_Chocolate.png',
      'primary_Cinder.png',
      'primary_Eggshell.png',
      'primary_Grey.png',
      'primary_Honey.png',
      'primary_Jade.png',
      'primary_Lavender.png',
      'primary_Olive.png',
      'primary_Pale.png',
      'primary_Porcelain.png',
      'primary_Sanguine.png',
      'primary_Storm.png',
      'primary_Sunbeam.png',
      'primary_Swarthy.png',
      'primary_White.png',
    ],
    'Mouth_-_Tusks': [
      'primary_Beige.png',
      'primary_Brick.png',
      'primary_Bronze.png',
      'primary_Caucasian.png',
      'primary_Celestial.png',
      'primary_Chestnut.png',
      'primary_Chocolate.png',
      'primary_Cinder.png',
      'primary_Dust.png',
      'primary_Grey.png',
      'primary_Honey.png',
      'primary_Jade.png',
      'primary_Lavender.png',
      'primary_Olive.png',
      'primary_Pale.png',
      'primary_Porcelain.png',
      'primary_Sanguine.png',
      'primary_Skeleton.png',
      'primary_Storm.png',
      'primary_Sunbeam.png',
      'primary_Swarthy.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Mouth_-_Whistle': [
      'primary_Beige.png',
      'primary_Brick.png',
      'primary_Bronze.png',
      'primary_Caucasian.png',
      'primary_Celestial.png',
      'primary_Chestnut.png',
      'primary_Chocolate.png',
      'primary_Cinder.png',
      'primary_Dust.png',
      'primary_Grey.png',
      'primary_Honey.png',
      'primary_Jade.png',
      'primary_Lavender.png',
      'primary_Olive.png',
      'primary_Pale.png',
      'primary_Porcelain.png',
      'primary_Sanguine.png',
      'primary_Skeleton.png',
      'primary_Storm.png',
      'primary_Sunbeam.png',
      'primary_Swarthy.png',
    ],
    'Nose_-_Broad': [
      'primary_Beige.png',
      'primary_Brick.png',
      'primary_Bronze.png',
      'primary_Caucasian.png',
      'primary_Celestial.png',
      'primary_Chestnut.png',
      'primary_Chocolate.png',
      'primary_Cinder.png',
      'primary_Dust.png',
      'primary_Grey.png',
      'primary_Honey.png',
      'primary_Jade.png',
      'primary_Lavender.png',
      'primary_Olive.png',
      'primary_Pale.png',
      'primary_Porcelain.png',
      'primary_Sanguine.png',
      'primary_Skeleton.png',
      'primary_Storm.png',
      'primary_Sunbeam.png',
      'primary_Swarthy.png',
    ],
    'Nose_-_Button_Nose': [
      'primary_Beige.png',
      'primary_Brick.png',
      'primary_Bronze.png',
      'primary_Caucasian.png',
      'primary_Celestial.png',
      'primary_Chestnut.png',
      'primary_Chocolate.png',
      'primary_Cinder.png',
      'primary_Dust.png',
      'primary_Grey.png',
      'primary_Honey.png',
      'primary_Jade.png',
      'primary_Lavender.png',
      'primary_Olive.png',
      'primary_Pale.png',
      'primary_Porcelain.png',
      'primary_Sanguine.png',
      'primary_Skeleton.png',
      'primary_Storm.png',
      'primary_Sunbeam.png',
      'primary_Swarthy.png',
    ],
    'Nose_-_Pointed': [
      'primary_Beige.png',
      'primary_Brick.png',
      'primary_Bronze.png',
      'primary_Caucasian.png',
      'primary_Celestial.png',
      'primary_Chestnut.png',
      'primary_Chocolate.png',
      'primary_Cinder.png',
      'primary_Dust.png',
      'primary_Grey.png',
      'primary_Honey.png',
      'primary_Jade.png',
      'primary_Lavender.png',
      'primary_Olive.png',
      'primary_Pale.png',
      'primary_Porcelain.png',
      'primary_Sanguine.png',
      'primary_Skeleton.png',
      'primary_Storm.png',
      'primary_Sunbeam.png',
      'primary_Swarthy.png',
    ],
    'Nose_-_Standard': [
      'primary_Beige.png',
      'primary_Brick.png',
      'primary_Bronze.png',
      'primary_Caucasian.png',
      'primary_Celestial.png',
      'primary_Chestnut.png',
      'primary_Chocolate.png',
      'primary_Cinder.png',
      'primary_Dust.png',
      'primary_Grey.png',
      'primary_Honey.png',
      'primary_Jade.png',
      'primary_Lavender.png',
      'primary_Olive.png',
      'primary_Pale.png',
      'primary_Porcelain.png',
      'primary_Sanguine.png',
      'primary_Skeleton.png',
      'primary_Storm.png',
      'primary_Sunbeam.png',
      'primary_Swarthy.png',
    ],
    'Nose_-_Witch_Nose': [
      'primary_Beige.png',
      'primary_Brick.png',
      'primary_Bronze.png',
      'primary_Caucasian.png',
      'primary_Celestial.png',
      'primary_Chestnut.png',
      'primary_Chocolate.png',
      'primary_Cinder.png',
      'primary_Dust.png',
      'primary_Grey.png',
      'primary_Honey.png',
      'primary_Jade.png',
      'primary_Lavender.png',
      'primary_Olive.png',
      'primary_Pale.png',
      'primary_Porcelain.png',
      'primary_Sanguine.png',
      'primary_Skeleton.png',
      'primary_Storm.png',
      'primary_Sunbeam.png',
      'primary_Swarthy.png',
    ],
    'Nose_-_Upturned': [
      'primary_Beige.png',
      'primary_Brick.png',
      'primary_Bronze.png',
      'primary_Caucasian.png',
      'primary_Celestial.png',
      'primary_Chestnut.png',
      'primary_Chocolate.png',
      'primary_Cinder.png',
      'primary_Dust.png',
      'primary_Grey.png',
      'primary_Honey.png',
      'primary_Jade.png',
      'primary_Lavender.png',
      'primary_Olive.png',
      'primary_Pale.png',
      'primary_Porcelain.png',
      'primary_Sanguine.png',
      'primary_Skeleton.png',
      'primary_Storm.png',
      'primary_Sunbeam.png',
      'primary_Swarthy.png',
    ],
    'Wound_-_Chin': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Wound_-_Claw': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Wound_-_Horizontal': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Wound_-_Forehead': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Wound_-_Skinless': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Wound_-_Vertical': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
  },
  Feet: {
    'Boots_-_Arctic_Boots': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Boots_-_Collared_Boots': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Boots_-_Go-Go_Boots': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Boots_-_Goblin_Boots': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Boots_-_Jewelled_Boots': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Boots_-_Mammoth_Boots': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Boots_-_Polainas': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Boots_-_Robot_Boots': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Boots_-_Solleret': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Boots_-_Spiked_Boots': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Boots_-_Tall_Boots': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Boots_-_Trappers_Furs': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Boots_-_Uniform_Boots': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Greaves_-_Anklet': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Boots_-_Wanderer_Boots': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Greaves_-_Banded_Schynbalds': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Greaves_-_Chausses': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Greaves_-_Kyahan': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Greaves_-_Poleyn': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Greaves_-_Gazer_Poleyn': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Greaves_-_Skull_Knee_Brace': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Greaves_-_Spiked_Greaves': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Greaves_-_Suneate': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Sandals_-_Flip_Flops': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Sandals_-_Geta': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Sandals_-_Gladiator_Sandals': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Sandals_-_Tabi': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Shoes_-_Arcane_Slippers': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Shoes_-_Babouche': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Shoes_-_Crakow': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Shoes_-_Clown_Shoes': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Shoes_-_Galesh': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Shoes_-_Loafers': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Shoes_-_High_Heels': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Shoes_-_Poulaine': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Shoes_-_Sabaton': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Shoes_-_Spatterdashes': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Socks_-_Gym_Socks': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Socks_-_Gartered_Stockings': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Socks_-_Leg_Wraps': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
  },
  Forehand: {
    'Club_-_Flail': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Club_-_Gata_Waka': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Club_-_Pernach': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Club_-_Shillelagh': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Club_-_Staff': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Club_-_War_Club': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Etc_-_Ceremonial_Boline': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Etc_-_Crutch': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Etc_-_Football': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Etc_-_Gorilla_Gauntlet': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Etc_-_Shopping_Bag': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Etc_-_Spell_Book': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Etc_-_Suitcase': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Etc_-_Teddy_Bear': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Etc_-_Tessen': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Instrument_-_Ceremonial_Drum': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Instrument_-_Musicians_Bow': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Knife_-_Bagh_Nakh': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Knife_-_Katar': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Knife_-_Moon_Knife': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Ranged_-_Buster_Cannon': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Knife_-_Surik': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Ranged_-_Chakram': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Ranged_-_Longbow': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Shield_-_Aegis': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Shield_-_Buckler': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Shield_-_Ancile': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Shield_-_Heater_Shield': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Shield_-_Kite_Shield': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Shield_-_Maduvu': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Shield_-_Mech_Shield': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Shield_-_Nguba': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Shield_-_Pavise': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Shield_-_Pelte_Shield': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Shield_-_Pridwen': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Shield_-_Rondache': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Shield_-_Scutum': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Shield_-_Targe': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Sword_-_Broadsword': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Sword_-_Butterfly_Sword': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Sword_-_Crescent_Blade': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Sword_-_Cutlass': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Sword_-_Dandpatta': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Sword_-_Epee': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Sword_-_Falcata': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Sword_-_Khopesh': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Sword_-_Sabre': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Sword_-_Falchion': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
  },
  Hair: {
    '0001': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0002': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0003': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0004': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0005': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0007': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0006': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    '0008': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0009': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0011': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0010': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    '0012': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    '0013': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0014': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0015': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    '0016': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    '0018': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0017': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0019': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0020': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0021': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0023': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0022': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0024': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0025': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0026': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0028': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0027': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0029': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0030': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0032': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0031': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    '0033': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0034': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0035': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0036': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0037': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0038': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0039': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0040': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0041': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0042': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    '0043': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0044': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0045': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0046': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0047': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0048': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0049': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    '0050': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    '0051': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0053': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0052': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    '0054': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0055': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    '0056': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0057': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0058': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0059': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0060': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0062': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0061': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    '0063': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0065': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0064': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    '0066': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    '0067': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0069': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0068': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0070': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0071': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0072': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0073': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0074': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0075': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0077': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0076': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    '0078': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0079': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0081': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0082': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0080': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    '0083': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0084': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0086': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0085': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0087': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    '0088': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0089': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0090': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0091': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0092': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0093': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0094': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0095': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    '0096': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0097': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0098': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    '0099': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    '0100': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0101': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0102': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0103': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    '0104': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    '0105': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    '0106': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    '0107': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    '0109': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0108': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    '0110': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0111': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    '0112': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0114': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0113': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    '0116': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0115': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    '0118': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0117': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    '0119': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0120': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    '0121': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0122': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0123': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    '0124': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0125': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    '0126': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    '0128': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0129': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    '0130': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0127': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    '0131': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0133': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    '0132': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    '0134': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
  },
  Headgear: {
    'Crown_-_Deshret': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Crown_-_Diadem': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Crown_-_Fishers_Crown': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Crown_-_Eastern_Diadem': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Crown_-_Hedjet': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Crown_-_Khepresh': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Crown_-_Oceanic_Crown': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Crown_-_Mitre': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Crown_-_Pschent': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Crown_-_Tiara': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Crown_-_Villians_Crown': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Crown_-_Warrior_Crown': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Crown_-_Winged_Crown': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Hat_-_Adventure_Cap': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Hat_-_Beret': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Hat_-_Banded_Cloche': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Hat_-_Bearskin_Cap': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Hat_-_Bicorn_Hat': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Hat_-_Boqta': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Hat_-_Bycoket': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Hat_-_Castoreno': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Hat_-_Cavalier_Cap': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Hat_-_Colback': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Hat_-_Combination_Cap': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Hat_-_Cowboy_Hat': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Hat_-_Deerstalker_Cap': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Hat_-_Doppi': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Hat_-_Explorer_Cap': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Hat_-_Fez': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Hat_-_Freighter_Cap': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Hat_-_Fulani_Hat': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Hat_-_Gangster_Hat': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Hat_-_Gardener_Bonet': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Hat_-_Gourmand_Cap': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Hat_-_Grave_Witch_Cap': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Hat_-_Hanfu_Guan': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Hat_-_Imp_Cap': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Hat_-_Jester_Cap': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Hat_-_Kasa': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Hat_-_Kalpak': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Hat_-_Kilmarnock_Bonnet': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Hat_-_Knit_Tuque': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Hat_-_Kraken_Cap': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Hat_-_Loovuuz': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Hat_-_Lunar_Cap': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Hat_-_Mage_Hat': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Hat_-_Mariners_Cap': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Hat_-_Monmouth_Cap': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Hat_-_Mountebank_Cap': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Hat_-_Oracles_Ba_Tam': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Hat_-_Papakha': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Hat_-_Peregrina_Hat': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Hat_-_Petasos': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Hat_-_Phrygian_Cap': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Hat_-_Produce_Hat': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Hat_-_Sailors_Cap': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Hat_-_Pillbox_Hat': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Hat_-_Quail_Cap': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Hat_-_Shtreimel': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Hat_-_Sorcery_Cap': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Hat_-_Sultan_Cap': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Hat_-_Swashbuckler_Hat': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Hat_-_Tengai': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Hat_-_Trickster_Cap': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Hat_-_Thrum_Cap': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Hat_-_Tricorner_Hat': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Hat_-_Troubador_Hat': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Hat_-_Vigilante_Hat': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Hat_-_Wide_Brimmed_Hat': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Hat_-_Yarmulke': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Headscarf_-_Alentejo_Headscarf': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Headscarf_-_Assassin_Mask': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Headscarf_-_Cachene_Headscarf': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Headscarf_-_Chador': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Headscarf_-_Congolese_Headdress': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Headscarf_-_Divinity_Headress': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Headscarf_-_Escoffion': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Headscarf_-_Habit': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Headscarf_-_Ghutra': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Headscarf_-_Hachimaki': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Headscarf_-_Heart-Shaped_Headdress': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Headscarf_-_Hijab': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Headscarf_-_Jamana': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Headscarf_-_Hennin': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Headscarf_-_Keffiyeh': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Headscarf_-_Mingrelian_Headscarf': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Headscarf_-_Nemes': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Headscarf_-_Nihang_Turban': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Headscarf_-_Niqaab': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Headscarf_-_Pirate_Bandana': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Headscarf_-_Platform_Hat': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Headscarf_-_Nomad_Turban': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Headscarf_-_Raiders_Hood': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Headscarf_-_Silk_Headband': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Headscarf_-_Sohei_Zukin': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Headscarf_-_Society_Veil': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Headscarf_-_Tagelmust': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Headscarf_-_Tenugui_Shawl': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Headscarf_-_Thieves_Tenugui': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Headscarf_-_Turban': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Headscarf_-_Wodaabe_Headscarf': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Helmet_-_Bascinet': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Helmet_-_Barbute': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Helmet_-_Bogu': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Helmet_-_Broe_Helm': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Helmet_-_Combatant_Helm': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Helmet_-_Confessor': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Helmet_-_Convict_Helm': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Helmet_-_Corinthian': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Helmet_-_Decorated_Burgonet': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Helmet_-_Dragonfiend': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Helmet_-_Dwarvish_Helm': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'Secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Helmet_-_Flight_Helm': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Helmet_-_Galea': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Helmet_-_Gatekeeper_Helm': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Helmet_-_Great_Helm': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Helmet_-_Guard_Captain_Helm': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Helmet_-_Heavy_Shell_Helm': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Helmet_-_Hunters_Helm': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Helmet_-_Insurgent_Helm': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Helmet_-_Joseon': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Helmet_-_Kabuto': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Helmet_-_Kawari_Helmet': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Helmet_-_Lamellar': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Helmet_-_Marquis_Helm': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Helmet_-_Mech_Kabuto': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Helmet_-_Morion': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Helmet_-_Momonari': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Helmet_-_Nautilus_Helm': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Helmet_-_Renaissance_Helm': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Helmet_-_Retro-Futurist_Helm': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Helmet_-_Ram_Knight': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Helmet_-_Robot_Helm': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Helmet_-_Sallet': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Helmet_-_Screen_Helm': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Helmet_-_Segmented_Helm': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Helmet_-_Shaman_Skull': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Helmet_-_Spartan_Helm': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Helmet_-_Squire_Helm': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Helmet_-_Stechhelm': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Helmet_-_Underworld_Helm': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Helmet_-_Vacuum_Helm': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Hood_-_Adept_Hood': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Helmet_-_Winged_Helm': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Helmet_-_Wolfhunter_Helm': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Hood_-_Aventail': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Hood_-_Bashlyk': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Hood_-_Capuz_De_Honras': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Hood_-_Cap_And_Bells': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'seconadry_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Hood_-_Careto_Garruco': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Hood_-_Chaperon': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Hood_-_Cultist_Hood': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Hood_-_Druid_Hood': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Hood_-_Chainmail_Hood': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Hood_-_Embroidered_Hood': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Hood_-_Executioner_Hood': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Hood_-_Fortune_Tellers_Hood': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Hood_-_Gargush': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Hood_-_Hermit_Shawl': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Hood_-_Hitaiate_Kusari': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Hood_-_Mischief_Hood': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Hood_-_Mudang_Hood': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Hood_-_Stalkers_Hood': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Hood_-_Rainmaker_Hood': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Hood_-_Thief_Hood': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Pelt_-_Cernunnos_Hood': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Pelt_-_Coonskin_Cap': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Pelt_-_Crow_Shaman_Hood': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Pelt_-_Feathered_Cowl': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Pelt_-_Lizard_Hide': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Pelt_-_Nemean_Lion': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Pelt_-_Polyp_Hood': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Pelt_-_Savage_Mane': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Pelt_-_Wolfskin': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
  },
  Lower_Body: {
    'Fauld_-_Decorated_Fauld': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Fauld_-_Fauld': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Fauld_-_Haidate': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Fauld_-_Obidome': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Full_Body_-_Overalls': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Fauld_-_Scout_Faulds': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Full_Body_-_Unitard': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Pants_-_Bellbottoms': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Pants_-_Bontan_Pants': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Pants_-_Calzones_De_Gala': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Pants_-_Calzona_De_Gamuza': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Pants_-_Careto_Trousers': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Pants_-_Chaps': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Pants_-_Cuffed_Pants': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Pants_-_Dress_Slacks': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Pants_-_Gallyhosen': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Pants_-_Hakama': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Pants_-_Harem_Pants': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Pants_-_Keikogi_Zubon': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Pants_-_Huntress_Greaves': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Pants_-_Knee_Breeches': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Pants_-_Leather_Pants': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Pants_-_Merchant_Slacks': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Pants_-_Naga_Bakama': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Pants_-_Mining_Pants': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Pants_-_Primate_Pants': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Pants_-_Sailors_Slops': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Pants_-_Taleguilla': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Pants_-_Track_Pants': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Pants_-_Trews': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Pants_-_Trousers': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Pants_-_Striped_Slacks': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Pants_-_Vacuum_Slacks': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Shorts_-_Atheletic_Shorts': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Shorts_-_Cargo_Shorts': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Shorts_-_Striped_Shorts': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Shorts_-_Cuffed_Shorts': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Shorts_-_Swindler_Fatigues': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Skirt_-_Ascetic_Wrap': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Skirt_-_Barbarian_Rags': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Skirt_-_Combatant_Wrap': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Skirt_-_Cultist_Sash': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Skirt_-_Grass_Skirt': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Skirt_-_Kilt': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Skirt_-_Layered_Trail_Dress': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Skirt_-_Necromancer_Tatters': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Skirt_-_Petticoat_Breeches': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Skirt_-_Phaoroh_Cloth': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Skirt_-_Saia': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Skirt_-_Regal_Sash': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Skirt_-_Sarong': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Skirt_-_Savage_Skirt': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Skirt_-_Shendyt': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Skirt_-_Sherpa_Wrap': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Skirt_-_Skirt': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Skirt_-_Towel': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Skirt_-_Tutu': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Skirt_-_Wanderers_Skirt': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Undergarment_-_Bikini': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Undergarment_-_Briefs': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Undergarment_-_Codpiece': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Undergarment_-_Derpey': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Undergarment_-_High_Rise_Stockings': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Undergarment_-_Loincloth': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Undergarment_-_Underclothes': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
  },
  Physique: {
    'Animal_Head_-_Ape': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Beige.png',
      'secondary_Brick.png',
      'secondary_Bronze.png',
      'secondary_Caucasian.png',
      'secondary_Celestial.png',
      'secondary_Chestnut.png',
      'secondary_Chocolate.png',
      'secondary_Cinder.png',
      'secondary_Dust.png',
      'secondary_Grey.png',
      'secondary_Honey.png',
      'secondary_Jade.png',
      'secondary_Lavender.png',
      'secondary_None.png',
      'secondary_Olive.png',
      'secondary_Pale.png',
      'secondary_Porcelain.png',
      'secondary_Sanguine.png',
      'secondary_Storm.png',
      'secondary_Sunbeam.png',
      'secondary_Swarthy.png',
    ],
    'Animal_Head_-_Baphomet': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Animal_Head_-_Bull': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Animal_Head_-_Cormorant': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Animal_Head_-_Eagle': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Animal_Head_-_Heron': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Animal_Head_-_Falcon': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Animal_Head_-_Lion': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Animal_Head_-_Land_Mammal': [
      'primary_Beige.png',
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brick.png',
      'primary_Bronze.png',
      'primary_Brown.png',
      'primary_Caucasian.png',
      'primary_Celestial.png',
      'primary_Chestnut.png',
      'primary_Chocolate.png',
      'primary_Cinder.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Dusky.png',
      'primary_Dust.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Grey.png',
      'primary_Honey.png',
      'primary_Jade.png',
      'primary_Lavender.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Olive.png',
      'primary_Pale.png',
      'primary_Pink.png',
      'primary_Porcelain.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sanguine.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Skeleton.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Storm.png',
      'primary_Sunbeam.png',
      'primary_Swarthy.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Beige.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brick.png',
      'secondary_Bronze.png',
      'secondary_Brown.png',
      'secondary_Caucasian.png',
      'secondary_Celestial.png',
      'secondary_Chestnut.png',
      'secondary_Chocolate.png',
      'secondary_Cinder.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Dust.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Grey.png',
      'secondary_Honey.png',
      'secondary_Jade.png',
      'secondary_Lavender.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Olive.png',
      'secondary_Pale.png',
      'secondary_Pink.png',
      'secondary_Porcelain.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sanguine.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Storm.png',
      'secondary_Sunbeam.png',
      'secondary_Swarthy.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Animal_Head_-_Lizard': [
      'primary_Beige.png',
      'primary_Brick.png',
      'primary_Bronze.png',
      'primary_Caucasian.png',
      'primary_Celestial.png',
      'primary_Chestnut.png',
      'primary_Chocolate.png',
      'primary_Cinder.png',
      'primary_Dust.png',
      'primary_Grey.png',
      'primary_Honey.png',
      'primary_Jade.png',
      'primary_Lavender.png',
      'primary_Olive.png',
      'primary_Pale.png',
      'primary_Porcelain.png',
      'primary_Sanguine.png',
      'primary_Skeleton.png',
      'primary_Storm.png',
      'primary_Sunbeam.png',
      'primary_Swarthy.png',
    ],
    'Animal_Head_-_Toad_Face': [
      'primary_Beige.png',
      'primary_Brick.png',
      'primary_Bronze.png',
      'primary_Caucasian.png',
      'primary_Celestial.png',
      'primary_Chestnut.png',
      'primary_Chocolate.png',
      'primary_Cinder.png',
      'primary_Dust.png',
      'primary_Grey.png',
      'primary_Honey.png',
      'primary_Jade.png',
      'primary_Lavender.png',
      'primary_Olive.png',
      'primary_Pale.png',
      'primary_Porcelain.png',
      'primary_Sanguine.png',
      'primary_Skeleton.png',
      'primary_Storm.png',
      'primary_Sunbeam.png',
      'primary_Swarthy.png',
    ],
    'Animal_Head_-_Raven': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Animal_Head_-_Trout_Mask': [
      'primary_Beige.png',
      'primary_Brick.png',
      'primary_Bronze.png',
      'primary_Caucasian.png',
      'primary_Celestial.png',
      'primary_Chestnut.png',
      'primary_Chocolate.png',
      'primary_Cinder.png',
      'primary_Dust.png',
      'primary_Grey.png',
      'primary_Honey.png',
      'primary_Jade.png',
      'primary_Lavender.png',
      'primary_Olive.png',
      'primary_Pale.png',
      'primary_Porcelain.png',
      'primary_Sanguine.png',
      'primary_Storm.png',
      'primary_Sunbeam.png',
      'primary_Swarthy.png',
    ],
    'Animal_Head_-_Owl': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Animal_Head_-_Vulture': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Etc_-_Automaton': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Etc_-_Closed_Eyes': [
      'primary_Beige.png',
      'primary_Brick.png',
      'primary_Bronze.png',
      'primary_Caucasian.png',
      'primary_Celestial.png',
      'primary_Chestnut.png',
      'primary_Chocolate.png',
      'primary_Cinder.png',
      'primary_Dust.png',
      'primary_Grey.png',
      'primary_Honey.png',
      'primary_Jade.png',
      'primary_Lavender.png',
      'primary_None.png',
      'primary_Olive.png',
      'primary_Pale.png',
      'primary_Porcelain.png',
      'primary_Sanguine.png',
      'primary_Skeleton.png',
      'primary_Storm.png',
      'primary_Sunbeam.png',
      'primary_Swarthy.png',
      'secondary_Beige.png',
      'secondary_Brick.png',
      'secondary_Bronze.png',
      'secondary_Caucasian.png',
      'secondary_Celestial.png',
      'secondary_Chestnut.png',
      'secondary_Chocolate.png',
      'secondary_Cinder.png',
      'secondary_Dust.png',
      'secondary_Grey.png',
      'secondary_Honey.png',
      'secondary_Jade.png',
      'secondary_Lavender.png',
      'secondary_None.png',
      'secondary_Olive.png',
      'secondary_Pale.png',
      'secondary_Porcelain.png',
      'secondary_Sanguine.png',
      'secondary_Skeleton.png',
      'secondary_Storm.png',
      'secondary_Sunbeam.png',
      'secondary_Swarthy.png',
    ],
    'Etc_-_Compound_Eyes': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Etc_-_Eye_Color': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Etc_-_Folded_Wing': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Etc_-_Eye_of_Newt': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Head_-_Bifurcated_Face': [
      'primary_Beige.png',
      'primary_Brick.png',
      'primary_Bronze.png',
      'primary_Caucasian.png',
      'primary_Celestial.png',
      'primary_Chestnut.png',
      'primary_Chocolate.png',
      'primary_Cinder.png',
      'primary_Dust.png',
      'primary_Grey.png',
      'primary_Honey.png',
      'primary_Jade.png',
      'primary_Lavender.png',
      'primary_Olive.png',
      'primary_Pale.png',
      'primary_Porcelain.png',
      'primary_Sanguine.png',
      'primary_Skeleton.png',
      'primary_Storm.png',
      'primary_Sunbeam.png',
      'primary_Swarthy.png',
    ],
    'Head_-_Enlarged_Lobes': [
      'primary_Beige.png',
      'primary_Brick.png',
      'primary_Bronze.png',
      'primary_Caucasian.png',
      'primary_Celestial.png',
      'primary_Chestnut.png',
      'primary_Chocolate.png',
      'primary_Cinder.png',
      'primary_Dust.png',
      'primary_Grey.png',
      'primary_Honey.png',
      'primary_Jade.png',
      'primary_Lavender.png',
      'primary_Olive.png',
      'primary_Pale.png',
      'primary_Porcelain.png',
      'primary_Sanguine.png',
      'primary_Skeleton.png',
      'primary_Storm.png',
      'primary_Sunbeam.png',
      'primary_Swarthy.png',
    ],
    'Head_-_Cyclops_Eye': [
      'primary_Beige.png',
      'primary_Brick.png',
      'primary_Bronze.png',
      'primary_Caucasian.png',
      'primary_Celestial.png',
      'primary_Chestnut.png',
      'primary_Chocolate.png',
      'primary_Cinder.png',
      'primary_Dust.png',
      'primary_Grey.png',
      'primary_Honey.png',
      'primary_Jade.png',
      'primary_Lavender.png',
      'primary_Olive.png',
      'primary_Pale.png',
      'primary_Porcelain.png',
      'primary_Sanguine.png',
      'primary_Skeleton.png',
      'primary_Storm.png',
      'primary_Sunbeam.png',
      'primary_Swarthy.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Head_-_Flame': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Head_-_Forehead_Loaf': [
      'primary_Beige.png',
      'primary_Brick.png',
      'primary_Bronze.png',
      'primary_Caucasian.png',
      'primary_Celestial.png',
      'primary_Chestnut.png',
      'primary_Chocolate.png',
      'primary_Cinder.png',
      'primary_Dust.png',
      'primary_Grey.png',
      'primary_Honey.png',
      'primary_Jade.png',
      'primary_Lavender.png',
      'primary_Olive.png',
      'primary_Pale.png',
      'primary_Porcelain.png',
      'primary_Sanguine.png',
      'primary_Skeleton.png',
      'primary_Storm.png',
      'primary_Sunbeam.png',
      'primary_Swarthy.png',
    ],
    'Head_-_Gaunt_Cheeks': [
      'primary_Beige.png',
      'primary_Brick.png',
      'primary_Bronze.png',
      'primary_Caucasian.png',
      'primary_Celestial.png',
      'primary_Chestnut.png',
      'primary_Chocolate.png',
      'primary_Cinder.png',
      'primary_Dust.png',
      'primary_Grey.png',
      'primary_Honey.png',
      'primary_Jade.png',
      'primary_Lavender.png',
      'primary_Olive.png',
      'primary_Pale.png',
      'primary_Porcelain.png',
      'primary_Sanguine.png',
      'primary_Skeleton.png',
      'primary_Storm.png',
      'primary_Sunbeam.png',
      'primary_Swarthy.png',
    ],
    'Head_-_Grotesque_Blob': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Head_-_Lump': [
      'primary_Beige.png',
      'primary_Brick.png',
      'primary_Bronze.png',
      'primary_Caucasian.png',
      'primary_Celestial.png',
      'primary_Chestnut.png',
      'primary_Chocolate.png',
      'primary_Cinder.png',
      'primary_Dust.png',
      'primary_Grey.png',
      'primary_Honey.png',
      'primary_Jade.png',
      'primary_Lavender.png',
      'primary_Olive.png',
      'primary_Pale.png',
      'primary_Porcelain.png',
      'primary_Sanguine.png',
      'primary_Storm.png',
      'primary_Sunbeam.png',
      'primary_Swarthy.png',
    ],
    'Head_-_Neanderthal_Brow': [
      'primary_Beige.png',
      'primary_Brick.png',
      'primary_Bronze.png',
      'primary_Caucasian.png',
      'primary_Celestial.png',
      'primary_Chestnut.png',
      'primary_Chocolate.png',
      'primary_Cinder.png',
      'primary_Dust.png',
      'primary_Grey.png',
      'primary_Honey.png',
      'primary_Jade.png',
      'primary_Lavender.png',
      'primary_Olive.png',
      'primary_Pale.png',
      'primary_Porcelain.png',
      'primary_Sanguine.png',
      'primary_Storm.png',
      'primary_Sunbeam.png',
      'primary_Swarthy.png',
    ],
    'Head_-_Tall_Head': [
      'primary_Beige.png',
      'primary_Brick.png',
      'primary_Bronze.png',
      'primary_Caucasian.png',
      'primary_Celestial.png',
      'primary_Chestnut.png',
      'primary_Chocolate.png',
      'primary_Cinder.png',
      'primary_Dust.png',
      'primary_Grey.png',
      'primary_Honey.png',
      'primary_Jade.png',
      'primary_Lavender.png',
      'primary_Olive.png',
      'primary_Pale.png',
      'primary_Porcelain.png',
      'primary_Sanguine.png',
      'primary_Skeleton.png',
      'primary_Storm.png',
      'primary_Sunbeam.png',
      'primary_Swarthy.png',
    ],
    'Head_-_Space_Parasite': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Head_-_Tentacles': [
      'primary_Beige.png',
      'primary_Brick.png',
      'primary_Bronze.png',
      'primary_Caucasian.png',
      'primary_Celestial.png',
      'primary_Chestnut.png',
      'primary_Chocolate.png',
      'primary_Cinder.png',
      'primary_Dust.png',
      'primary_Grey.png',
      'primary_Honey.png',
      'primary_Jade.png',
      'primary_Lavender.png',
      'primary_None.png',
      'primary_Olive.png',
      'primary_Pale.png',
      'primary_Porcelain.png',
      'primary_Sanguine.png',
      'primary_Skeleton.png',
      'primary_Storm.png',
      'primary_Sunbeam.png',
      'primary_Swarthy.png',
      'secondary_Beige.png',
      'secondary_Brick.png',
      'secondary_Bronze.png',
      'secondary_Caucasian.png',
      'secondary_Celestial.png',
      'secondary_Chestnut.png',
      'secondary_Chocolate.png',
      'secondary_Cinder.png',
      'secondary_Dust.png',
      'secondary_Grey.png',
      'secondary_Honey.png',
      'secondary_Jade.png',
      'secondary_Lavender.png',
      'secondary_None.png',
      'secondary_Olive.png',
      'secondary_Pale.png',
      'secondary_Porcelain.png',
      'secondary_Sanguine.png',
      'secondary_Skeleton.png',
      'secondary_Storm.png',
      'secondary_Sunbeam.png',
      'secondary_Swarthy.png',
    ],
    'Head_-_Treant': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Lower_Body_-_Arachnid_Legs': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Lower_Body_-_Centaur': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Lower_Body_-_Claws': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Lower_Body_-_Dryad_Roots': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Lower_Body_-_Djinn_Lamp': [
      'primary_Beige.png',
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brick.png',
      'primary_Bronze.png',
      'primary_Brown.png',
      'primary_Caucasian.png',
      'primary_Celestial.png',
      'primary_Chestnut.png',
      'primary_Chocolate.png',
      'primary_Cinder.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Dust.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Grey.png',
      'primary_Honey.png',
      'primary_Jade.png',
      'primary_Lavender.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Olive.png',
      'primary_Pale.png',
      'primary_Pink.png',
      'primary_Porcelain.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sanguine.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Storm.png',
      'primary_Sunbeam.png',
      'primary_Swarthy.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brick.png',
      'secondary_Bronze.png',
      'secondary_Brown.png',
      'secondary_Caucasian.png',
      'secondary_Chocolate.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Dusky.png',
      'secondary_Dust.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Grey.png',
      'secondary_Honey.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Olive.png',
      'secondary_Pale.png',
      'secondary_Pink.png',
      'secondary_Porcelain.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Lower_Body_-_Halfling_Feet': [
      'primary_Beige.png',
      'primary_Brick.png',
      'primary_Bronze.png',
      'primary_Caucasian.png',
      'primary_Celestial.png',
      'primary_Chestnut.png',
      'primary_Chocolate.png',
      'primary_Cinder.png',
      'primary_Dust.png',
      'primary_Grey.png',
      'primary_Honey.png',
      'primary_Jade.png',
      'primary_Lavender.png',
      'primary_Olive.png',
      'primary_Pale.png',
      'primary_Porcelain.png',
      'primary_Sanguine.png',
      'primary_Skeleton.png',
      'primary_Storm.png',
      'primary_Sunbeam.png',
      'primary_Swarthy.png',
    ],
    'Lower_Body_-_Harpy_Legs': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Lower_Body_-_Merfolk_Tail': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Lower_Body_-_Phallus': [
      'primary_Beige.png',
      'primary_Brick.png',
      'primary_Bronze.png',
      'primary_Caucasian.png',
      'primary_Celestial.png',
      'primary_Chestnut.png',
      'primary_Chocolate.png',
      'primary_Cinder.png',
      'primary_Dust.png',
      'primary_Grey.png',
      'primary_Honey.png',
      'primary_Jade.png',
      'primary_Lavender.png',
      'primary_Olive.png',
      'primary_Pale.png',
      'primary_Porcelain.png',
      'primary_Sanguine.png',
      'primary_Skeleton.png',
      'primary_Storm.png',
      'primary_Sunbeam.png',
      'primary_Swarthy.png',
    ],
    'Lower_Body_-_Naga_Coil': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Lower_Body_-_Satyr_Hoof': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Upper_Body_-_Ale_Belly': [
      'primary_Beige.png',
      'primary_Brick.png',
      'primary_Bronze.png',
      'primary_Caucasian.png',
      'primary_Celestial.png',
      'primary_Chestnut.png',
      'primary_Chocolate.png',
      'primary_Cinder.png',
      'primary_Dust.png',
      'primary_Grey.png',
      'primary_Honey.png',
      'primary_Jade.png',
      'primary_Lavender.png',
      'primary_Olive.png',
      'primary_Pale.png',
      'primary_Porcelain.png',
      'primary_Sanguine.png',
      'primary_Skeleton.png',
      'primary_Storm.png',
      'primary_Sunbeam.png',
      'primary_Swarthy.png',
    ],
    'Upper_Body_-_Bare_Breasts': [
      'primary_Beige.png',
      'primary_Brick.png',
      'primary_Bronze.png',
      'primary_Caucasian.png',
      'primary_Celestial.png',
      'primary_Chestnut.png',
      'primary_Chocolate.png',
      'primary_Cinder.png',
      'primary_Dust.png',
      'primary_Grey.png',
      'primary_Honey.png',
      'primary_Jade.png',
      'primary_Lavender.png',
      'primary_Olive.png',
      'primary_Pale.png',
      'primary_Porcelain.png',
      'primary_Sanguine.png',
      'primary_Skeleton.png',
      'primary_Storm.png',
      'primary_Sunbeam.png',
      'primary_Swarthy.png',
    ],
    'Upper_Body_-_Brute_Strength': [
      'primary_Beige.png',
      'primary_Brick.png',
      'primary_Bronze.png',
      'primary_Caucasian.png',
      'primary_Celestial.png',
      'primary_Chestnut.png',
      'primary_Chocolate.png',
      'primary_Cinder.png',
      'primary_Dust.png',
      'primary_Grey.png',
      'primary_Honey.png',
      'primary_Jade.png',
      'primary_Lavender.png',
      'primary_Olive.png',
      'primary_Pale.png',
      'primary_Porcelain.png',
      'primary_Sanguine.png',
      'primary_Skeleton.png',
      'primary_Storm.png',
      'primary_Sunbeam.png',
      'primary_Swarthy.png',
    ],
    'Upper_Body_-_Chest_Hair': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Upper_Body_-_Creepy_Arms': [
      'primary_Beige.png',
      'primary_Brick.png',
      'primary_Bronze.png',
      'primary_Caucasian.png',
      'primary_Celestial.png',
      'primary_Chestnut.png',
      'primary_Chocolate.png',
      'primary_Cinder.png',
      'primary_Dust.png',
      'primary_Grey.png',
      'primary_Honey.png',
      'primary_Jade.png',
      'primary_Lavender.png',
      'primary_Olive.png',
      'primary_Pale.png',
      'primary_Porcelain.png',
      'primary_Sanguine.png',
      'primary_Skeleton.png',
      'primary_Storm.png',
      'primary_Sunbeam.png',
      'primary_Swarthy.png',
    ],
    'Upper_Body_-_Hidden_Twin': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Brick.png',
      'primary_Brown.png',
      'primary_Caucasian.png',
      'primary_Chocolate.png',
      'primary_Dust.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Grey.png',
      'primary_Honey.png',
      'primary_Night.png',
      'primary_Olive.png',
      'primary_Pale.png',
      'primary_Porcelain.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Skeleton.png',
      'primary_Swarthy.png',
      'primary_Tan.png',
      'primary_Yellow.png',
    ],
    'Upper_Body_-_Grotesque_Blob': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Upper_Body_-_Hunchback': [
      'primary_Beige.png',
      'primary_Brick.png',
      'primary_Bronze.png',
      'primary_Caucasian.png',
      'primary_Celestial.png',
      'primary_Chestnut.png',
      'primary_Chocolate.png',
      'primary_Cinder.png',
      'primary_Dust.png',
      'primary_Grey.png',
      'primary_Honey.png',
      'primary_Jade.png',
      'primary_Lavender.png',
      'primary_Olive.png',
      'primary_Pale.png',
      'primary_Porcelain.png',
      'primary_Sanguine.png',
      'primary_Skeleton.png',
      'primary_Storm.png',
      'primary_Sunbeam.png',
      'primary_Swarthy.png',
    ],
    'Upper_Body_-_Large_Hands': [
      'primary_Beige.png',
      'primary_Brick.png',
      'primary_Bronze.png',
      'primary_Caucasian.png',
      'primary_Celestial.png',
      'primary_Chestnut.png',
      'primary_Chocolate.png',
      'primary_Cinder.png',
      'primary_Dust.png',
      'primary_Grey.png',
      'primary_Honey.png',
      'primary_Jade.png',
      'primary_Lavender.png',
      'primary_Olive.png',
      'primary_Pale.png',
      'primary_Porcelain.png',
      'primary_Sanguine.png',
      'primary_Skeleton.png',
      'primary_Storm.png',
      'primary_Sunbeam.png',
      'primary_Swarthy.png',
    ],
    'Upper_Body_-_Mantis_Claws': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Upper_Body_-_Strong_Arm': [
      'primary_Beige.png',
      'primary_Brick.png',
      'primary_Bronze.png',
      'primary_Caucasian.png',
      'primary_Celestial.png',
      'primary_Chestnut.png',
      'primary_Chocolate.png',
      'primary_Cinder.png',
      'primary_Dust.png',
      'primary_Grey.png',
      'primary_Honey.png',
      'primary_Jade.png',
      'primary_Lavender.png',
      'primary_Olive.png',
      'primary_Pale.png',
      'primary_Porcelain.png',
      'primary_Sanguine.png',
      'primary_Storm.png',
      'primary_Sunbeam.png',
      'primary_Swarthy.png',
    ],
    'Upper_Body_-_Monstrous_Arm': [
      'primary_Beige.png',
      'primary_Brick.png',
      'primary_Bronze.png',
      'primary_Caucasian.png',
      'primary_Celestial.png',
      'primary_Chestnut.png',
      'primary_Chocolate.png',
      'primary_Cinder.png',
      'primary_Dust.png',
      'primary_Grey.png',
      'primary_Honey.png',
      'primary_Jade.png',
      'primary_Lavender.png',
      'primary_Olive.png',
      'primary_Pale.png',
      'primary_Porcelain.png',
      'primary_Sanguine.png',
      'primary_Skeleton.png',
      'primary_Storm.png',
      'primary_Sunbeam.png',
      'primary_Swarthy.png',
    ],
  },
  Robe: {
    'Cloak_-_Carriage_Cloak': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Cloak_-_Chlamys': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Cloak_-_Huntress_Cloak': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Cloak_-_Cope': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Cloak_-_Rainmaker_Cloak': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Coat_-_Alchemy_Coat': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Coat_-_Altembas': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Coat_-_Capa_Mirandesa': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Coat_-_Capote_Alentejano': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Coat_-_Chokha': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Coat_-_Royal_Celestial_Coat': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Coat_-_Sorcery_Coat': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Coat_-_Tonbi_Coat': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Coat_-_Trench_Coat': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Dress_-_Abaya': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Dress_-_Bubble_Dress': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Dress_-_Archery_Skirt': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Dress_-_Ceremonial_Gown': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Dress_-_Houppelande': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Dress_-_Huntress_Gown': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Dress_-_Kalasiris': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Dress_-_Kras': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Dress_-_Mentor_Dress': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Dress_-_Network_Dress': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Dress_-_Pious_Gown': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Dress_-_Sheer_Slip': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Dress_-_Stargazer_Gown': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Dress_-_Summoner_Dress': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Robes_-_Acolyte_Robes': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Dress_-_Witch_Dress': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Robes_-_Adept_Robes': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Robes_-_Bath_Robe': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Robes_-_Cassock': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Robes_-_Chiton': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Robes_-_Celebrant_Robes': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Robes_-_Cultist_Robe': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Robes_-_Deel': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Robes_-_Djellaba': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Robes_-_Druidic_Robe': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Robes_-_Dujeong_Gap': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Robes_-_Himation': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Robes_-_Laboratory_Robe': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Robes_-_Emperors_Mantle': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Robes_-_Monastic_Robe': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Robes_-_Nagajuban': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Robes_-_Open_Robe': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Robes_-_Onsen_Robe': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Robes_-_Owl_Robe': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Robes_-_Peplos': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Robes_-_Scholar_Toga': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Robes_-_Senetor_Sash': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Robes_-_Taraz': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Robes_-_Thawb': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Robes_-_Yukata': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Robes_-_Wool_Mente': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Robe_-_Chasuble': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Robe_-_Neanderthal_Furs': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Robe_-_Surplice': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Robe_-_Robe_of_Abundance': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
  },
  Sleeves: {
    Bare_Arm: [
      'primary_Beige.png',
      'primary_Brick.png',
      'primary_Bronze.png',
      'primary_Caucasian.png',
      'primary_Celestial.png',
      'primary_Chestnut.png',
      'primary_Chocolate.png',
      'primary_Cinder.png',
      'primary_Dust.png',
      'primary_Grey.png',
      'primary_Honey.png',
      'primary_Jade.png',
      'primary_Lavender.png',
      'primary_Olive.png',
      'primary_Pale.png',
      'primary_Porcelain.png',
      'primary_Sanguine.png',
      'primary_Skeleton.png',
      'primary_Storm.png',
      'primary_Sunbeam.png',
      'primary_Swarthy.png',
    ],
    Bracer: [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Brick.png',
      'primary_Bronze.png',
      'primary_Brown.png',
      'primary_Caucasian.png',
      'primary_Chocolate.png',
      'primary_Dust.png',
      'primary_Gold.png',
      'primary_Grey.png',
      'primary_Honey.png',
      'primary_Jade.png',
      'primary_Night.png',
      'primary_Olive.png',
      'primary_Pale.png',
      'primary_Porcelain.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Skeleton.png',
      'primary_Swarthy.png',
      'primary_Tan.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    Flowing_Sleeve: [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Brick.png',
      'primary_Bronze.png',
      'primary_Brown.png',
      'primary_Caucasian.png',
      'primary_Chocolate.png',
      'primary_Dust.png',
      'primary_Gold.png',
      'primary_Grey.png',
      'primary_Honey.png',
      'primary_Jade.png',
      'primary_Night.png',
      'primary_Olive.png',
      'primary_Pale.png',
      'primary_Porcelain.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Skeleton.png',
      'primary_Swarthy.png',
      'primary_Tan.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    Long_Sleeve: [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Brick.png',
      'primary_Bronze.png',
      'primary_Brown.png',
      'primary_Caucasian.png',
      'primary_Chocolate.png',
      'primary_Dust.png',
      'primary_Gold.png',
      'primary_Grey.png',
      'primary_Honey.png',
      'primary_Jade.png',
      'primary_Night.png',
      'primary_Olive.png',
      'primary_Pale.png',
      'primary_Porcelain.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Skeleton.png',
      'primary_Swarthy.png',
      'primary_Tan.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    Cloak: [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Brick.png',
      'primary_Bronze.png',
      'primary_Brown.png',
      'primary_Caucasian.png',
      'primary_Chocolate.png',
      'primary_Dust.png',
      'primary_Gold.png',
      'primary_Grey.png',
      'primary_Honey.png',
      'primary_Jade.png',
      'primary_Night.png',
      'primary_Olive.png',
      'primary_Pale.png',
      'primary_Porcelain.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Skeleton.png',
      'primary_Swarthy.png',
      'primary_Tan.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    Short_Sleeve: [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Brick.png',
      'primary_Bronze.png',
      'primary_Brown.png',
      'primary_Caucasian.png',
      'primary_Chocolate.png',
      'primary_Dust.png',
      'primary_Gold.png',
      'primary_Grey.png',
      'primary_Honey.png',
      'primary_Jade.png',
      'primary_Night.png',
      'primary_Olive.png',
      'primary_Pale.png',
      'primary_Porcelain.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Skeleton.png',
      'primary_Swarthy.png',
      'primary_Tan.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
  },
  Upper_Body: {
    'Armor_-_Arming_Doublet': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Armor_-_Banded_Vest': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Armor_-_Blemmyes_Platemail': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Armor_-_Bone_Platemail': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Armor_-_Breastplate': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Armor_-_Brigandine': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Armor_-_Chain_Hauberk': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Armor_-_Feathered_Breastplate': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Armor_-_Do_Maru': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Armor_-_Heavyweight_Plate': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Armor_-_Heavy_Gambeson': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Armor_-_Huntress_Armor': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Armor_-_Karuta_Do': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Armor_-_Kendogi': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Armor_-_Kuyak': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Armor_-_Lorica': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Armor_-_Light_Platemail': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Armor_-_Mach_Speed_Jacket': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
      'y_Copper.png',
    ],
    'Armor_-_Manchira': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Armor_-_Manjunowa': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Armor_-_Mech_Breastplate': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Armor_-_Medium_Platemail': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Armor_-_O-Yoroi': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Armor_-_Padded_Gambeson': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Armor_-_Plate_Coat': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Armor_-_Scout_Breastplate': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Armor_-_Serpent_Mail': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Coat_-_Asymmetrical_Coat': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Coat_-_Baja_Jacket': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Coat_-_Buccaneer_Coat': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Coat_-_Buff_Coat': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Coat_-_Captain_Jacket': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Coat_-_Careto_Coat': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Coat_-_Cavalier_Coat': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Coat_-_Cotehardie': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Coat_-_Draped_Greatcoat': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Coat_-_Earasaid': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Coat_-_Flight_Jacket': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Coat_-_Padded_Coat': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Coat_-_Performer_Coat': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Coat_-_Poncho': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Coat_-_Sealskin_Parka': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Coat_-_Smoking_Jacket': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Coat_-_Suit_Coat': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_None.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Coat_-_Track_Jacket': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Coat_-_Tuxedo_Coat': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Etc_-_Cross_Brace': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Etc_-_Xaile': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Pelt_-_Giant_Furs': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Etc_-_Urchin_Shawl': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Pelt_-_Gorilla_Chest': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Shirt_-_Agility_Wrap': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Pelt_-_Shaman_Furs': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Shirt_-_Baseball_Shirt': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Shirt_-_Blusa': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Shirt_-_Bounty_Hunter_Frock': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Shirt_-_Cadet_Uniform': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Shirt_-_Casual_Button-Up': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Shirt_-_Disheveled_Shirt': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Shirt_-_Farmers_Bodice': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Shirt_-_Fleet_Uniform': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Shirt_-_Hanten': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Shirt_-_Gakuran': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Shirt_-_Humble_Tunic': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Shirt_-_Jinbei': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Shirt_-_Long_Sleeved_Shirt': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Shirt_-_Keikogi_Uwagi': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Shirt_-_Noble_Blouse': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Shirt_-_Outsider_Shirt': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Shirt_-_Pleated_Dress_Shirt': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Shirt_-_Peasant_Shirt': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Shirt_-_Pretender_Fatigues': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Shirt_-_Princess_Bodice': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Shirt_-_Sailor_Shirt': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Shirt_-_Rainbow_Frock': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Shirt_-_Samue': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Shirt_-_Singlet': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Shirt_-_Smithing_Smock': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Shirt_-_Turtleneck_Sweater': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Shirt_-_Swashbuckler_Blouse': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Shirt_-_Vacuum_Suit': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Shirt_-_V_Neck_Shirt': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Shirt_-_Wanderers_Blouse': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Shirt_-_Zamarra_De_Pastor': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Undergarment_-_Brassiere': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Undergarment_-_Destitute_Barrel': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Undergarment_-_Modesty_Shells': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Undergarment_-_Sarashi_Band': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Vest_-_Dashing_Vest': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Vest_-_Double_Breasted_Waistcoat': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Vest_-_Fur_Collared_Vest': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_None.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Vest_-_High_Collared_Vest': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
    'Vest_-_Kataginu': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
      'secondary_Black.png',
      'secondary_Blue.png',
      'secondary_Bone.png',
      'secondary_Brown.png',
      'secondary_Copper.png',
      'secondary_Crimson.png',
      'secondary_Eggshell.png',
      'secondary_Flame.png',
      'secondary_Gold.png',
      'secondary_Green.png',
      'secondary_Maroon.png',
      'secondary_Mint.png',
      'secondary_Night.png',
      'secondary_Pink.png',
      'secondary_Purple.png',
      'secondary_Red.png',
      'secondary_Sea.png',
      'secondary_Silver.png',
      'secondary_Sky.png',
      'secondary_Stone.png',
      'secondary_Tan.png',
      'secondary_White.png',
      'secondary_Wood.png',
      'secondary_Yellow.png',
    ],
    'Vest_-_Kullaball': [
      'primary_Black.png',
      'primary_Blue.png',
      'primary_Bone.png',
      'primary_Brown.png',
      'primary_Copper.png',
      'primary_Crimson.png',
      'primary_Eggshell.png',
      'primary_Flame.png',
      'primary_Gold.png',
      'primary_Green.png',
      'primary_Maroon.png',
      'primary_Mint.png',
      'primary_Night.png',
      'primary_Pink.png',
      'primary_Purple.png',
      'primary_Red.png',
      'primary_Sea.png',
      'primary_Silver.png',
      'primary_Sky.png',
      'primary_Stone.png',
      'primary_Tan.png',
      'primary_White.png',
      'primary_Wood.png',
      'primary_Yellow.png',
    ],
  },
}

export default data
